import Vue from 'vue'
import psapApi from '@/apis/psap'
import commonApi from '@/apis/common'
import {
  RESET_STATE,
  GET_PSAP_REQUEST,
  GET_PSAP_SUCCESS,
  GET_PSAP_FAILURE,
  GET_PSAP_LIVESNAPSHOTURL_REQUEST,
  GET_PSAP_LIVESNAPSHOTURL_SUCCESS,
  GET_PSAP_LIVESNAPSHOTURL_FAILURE,
  GET_PSAP_LIVESNAPSHOT_REQUEST,
  GET_PSAP_LIVESNAPSHOT_SUCCESS,
  GET_PSAP_LIVESNAPSHOT_FAILURE,
  GET_PSAP_EVENT_REQUEST,
  GET_PSAP_EVENT_SUCCESS,
  GET_PSAP_EVENT_FAILURE,
  GET_PSAP_EVENT_MEDIAS_REQUEST,
  GET_PSAP_EVENT_MEDIAS_SUCCESS,
  GET_PSAP_EVENT_MEDIAS_FAILURE,
  GET_PSAP_EVENT_RECORD_REQUEST,
  GET_PSAP_EVENT_RECORD_SUCCESS,
  GET_PSAP_EVENT_RECORD_FAILURE,
  CHECK_EVENT_RECORD_CODEC_DONE
} from '../mutation-types'

let initialState = {
  dealer: {},
  site: {},
  contacts: [],
  activities: [],
  requester: {},
  liveSnapshotUrl: {},
  liveSnapshot: {},
  event: {},
  eventMedias: [],
  eventRecords: {},
  status: {
    getPsap: null,
    getLiveSnapshot: null,
    getLiveSnapshotUrl: null,
    getEvent: null,
    getEventMedias: null,
    getEventRecord: {},
    checkVideoCodec: null
  }
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  psapDealer: function (state) {
    return state.dealer
  },
  psapSite: function (state) {
    return state.site
  },
  psapContacts: function (state) {
    return state.contacts
  },
  psapActivities: function (state) {
    return state.activities
  },
  psapRequester: function (state) {
    return state.requester
  },
  psapLiveSnapshot: function (state) {
    return state.liveSnapshot
  },
  psapLiveSnapshotUrl: function (state) {
    return state.liveSnapshotUrl
  },
  psapEvent: function (state) {
    return state.event
  },
  psapEventMedias: function (state) {
    return state.eventMedias
  },
  psapEventRecords: function (state) {
    return function (recordId) {
      return state.eventRecords[recordId]
    }
  },
  statusGetPsap: function (state) {
    return state.status.getPsap
  },
  statusGetPsapLiveSnapshot: function (state) {
    return state.status.getLiveSnapshot
  },
  statusGetPsapEvent: function (state) {
    return state.status.getEvent
  },
  statusGetPsapEventMedias: function (state) {
    return state.status.getEventMedias
  },
  statusGetPsapEventRecord: function (state) {
    return function (recordId) {
      return state.status.getEventRecord[recordId]
    }
  },
  statusCheckPsapVideoCodec: function (state) {
    return state.status.checkVideoCodec
  },
  statusGetPsapLiveSnapshotUrl: function (state) {
    return state.status.getLiveSnapshotUrl
  }
}

// actions
const actions = {
  getPsap: function ({commit, dispatch}) {
    commit(GET_PSAP_REQUEST)
    return new Promise((resolve, reject) => {
      psapApi.getPsap().then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(GET_PSAP_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(GET_PSAP_FAILURE)
            reject(new Error(('No snapshot ' + err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_PSAP_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getPsapLiveSnapshot: function ({commit, dispatch}) {
    commit(GET_PSAP_LIVESNAPSHOT_REQUEST)
    return new Promise((resolve, reject) => {
      psapApi.getPsapLiveSnapshot().then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(GET_PSAP_LIVESNAPSHOT_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(GET_PSAP_LIVESNAPSHOT_FAILURE)
            reject(new Error(('No snapshot ' + err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_PSAP_LIVESNAPSHOT_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getPsapLiveSnapshotUrl: function ({commit, dispatch}) {
    commit(GET_PSAP_LIVESNAPSHOTURL_REQUEST)
    return new Promise((resolve, reject) => {
      psapApi.getPsapLiveSnapshotUrlV2().then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(GET_PSAP_LIVESNAPSHOTURL_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(GET_PSAP_LIVESNAPSHOTURL_FAILURE)
            reject(new Error(('No snapshot ' + err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_PSAP_LIVESNAPSHOTURL_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getPsapLiveSnapshotV2: function ({commit, dispatch}, {snapshotUrl, token}) {
    commit(GET_PSAP_LIVESNAPSHOT_REQUEST)
    return new Promise((resolve, reject) => {
      psapApi.getPsapLiveSnapshotV2(snapshotUrl, token).then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(GET_PSAP_LIVESNAPSHOT_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(GET_PSAP_LIVESNAPSHOT_FAILURE)
            reject(new Error(('No snapshot ' + err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_PSAP_LIVESNAPSHOT_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getPsapEvent: function ({commit, dispatch}) {
    commit(GET_PSAP_EVENT_REQUEST)
    commit(GET_PSAP_EVENT_MEDIAS_REQUEST)
    return new Promise((resolve, reject) => {
      psapApi.getPsapEvent().then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          if ('event' in res.body) {
            commit(GET_PSAP_EVENT_SUCCESS, {data: res.body['event']})
          } else {
            commit(GET_PSAP_EVENT_FAILURE)
          }
          if ('records' in res.body) {
            commit(GET_PSAP_EVENT_MEDIAS_SUCCESS, {data: res.body['records']})
          } else {
            commit(GET_PSAP_EVENT_MEDIAS_FAILURE)
          }
          resolve()
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_PSAP_EVENT_FAILURE)
          commit(GET_PSAP_EVENT_MEDIAS_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getPsapEventRecord: function ({commit, dispatch, getters}, {snapshotIndex, recordId, url}) {
    commit(GET_PSAP_EVENT_RECORD_REQUEST, {recordId: recordId})
    return new Promise((resolve, reject) => {
      commonApi.downloadImage(url).then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          commit(GET_PSAP_EVENT_RECORD_SUCCESS, {
            snapshotIndex: snapshotIndex,
            recordId: recordId,
            data: res.body
          })
          dispatch('checkEventRecordMP4Codec', {
            snapshotIndex: snapshotIndex,
            blob: res.body
          })
          resolve()
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_PSAP_EVENT_RECORD_FAILURE, {
            snapshotIndex: snapshotIndex,
            recordId: recordId
          })
          reject(new Error(err.statusText))
        }
      )
    })
  },
  checkEventRecordMP4Codec: function ({commit, dispatch, getters}, {snapshotIndex, blob}) {
    return new Promise((resolve, reject) => {
      // UPDATE codec
      let eventMedia = state.eventMedias[snapshotIndex]
      if (!eventMedia) return
      if (('' + eventMedia.format).toLocaleLowerCase() !== 'mp4') {
        resolve()
        return
      }
      Vue.tool.getCodecFromMP4(blob).then(codec => {
        commit(CHECK_EVENT_RECORD_CODEC_DONE, {
          snapshotIndex: snapshotIndex,
          codec: codec
        })
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  [RESET_STATE]: function (state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
  // //////////////////////////////////////////////
  [GET_PSAP_REQUEST]: function (state) {
    state.status.getPsap = 'requested'
  },
  [GET_PSAP_SUCCESS]: function (state, {data}) {
    try {
      // activity list and response list
      let activityList = []
      data.activity.map(activityData => {
        let activityInfo = {
          actionType: activityData.actionType,
          action: null,
          geoip: activityData.geoip,
          address: activityData.geoip_meta.city + ', ' + activityData.geoip_meta.country,
          lat: activityData.geoip_meta.latitude,
          lng: activityData.geoip_meta.longitude,
          geoIpMetaData: activityData.geoip_meta,
          createdDate: activityData.created ? new Date(activityData.created) : null
        }
        // set action in human readable format
        if (activityInfo.actionType === 0) {
          activityInfo.action = 'created'
        } else if (activityInfo.actionType === 1) {
          activityInfo.action = 'checked'
        } else {
          activityInfo.action = null
        }
        activityList.push(activityInfo)
      })
      state.activities = activityList
      // site
      let siteInfo = {
        siteId: data.site_id,
        customerAccountNumber: data.customer_account_number,
        siteName: data.name,
        address: (data.address2 ? data.address2 + ' ' : '') + data.address1,
        timezone: data.timezone,
        lat: data.lat,
        lng: data.lng
      }
      state.site = siteInfo
      // contacts
      let contacts = []
      data.contacts.map(contactData => {
        let contactInfo = {
          contactId: contactData.contact_id,
          title: contactData.title,
          name: contactData.name,
          email: contactData.email,
          phone: contactData.phone,
          slotNumber: contactData.slot_number
        }
        contacts.push(contactInfo)
      })
      state.contacts = contacts
      // dealerInfo
      let dealerData = data.requestby.dealer
      let dealerInfo = {
        dealerId: dealerData.dealer_id,
        dealerName: dealerData.company_name,
        locationInfo: {
          address: (dealerData.company_address2 ? dealerData.company_address2 + ' ' : '') + dealerData.company_address1,
          postalCode: dealerData.company_zipcode
        },
        contactInfo: {
          phone: dealerData.company_phone,
          email: dealerData.company_email
        }
      }
      state.dealer = dealerInfo
      // dealerInfo
      let userData = data.requestby.user
      let userInfo = {
        userId: userData.user_id,
        profilePictureUrl: userData.provider_picture,
        firstName: userData.account_firstname,
        lastName: userData.account_lastname,
        email: userData.email
      }
      state.requester = userInfo
      state.status.getPsap = 'successful'
    } catch (err) {
      Vue.logger.error('GET_PSAP_SUCCESS: Failed')
      Vue.logger.error(err)
      console.warn(err)
      state.status.getPsap = 'failed'
    }
  },
  [GET_PSAP_FAILURE]: function (state) {
    state.status.getPsap = 'failed'
  },
  // //////////////////////////////////////////////
  [GET_PSAP_LIVESNAPSHOTURL_REQUEST]: function (state) {
    state.status.getLiveSnapshotUrl = 'requested'
  },
  [GET_PSAP_LIVESNAPSHOTURL_SUCCESS]: function (state, {data}) {
    try {
      state.liveSnapshotUrl = data
      state.status.getLiveSnapshotUrl = 'successful'
    } catch (err) {
      Vue.logger.error('GET_PSAP_LIVESNAPSHOTURL_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getLiveSnapshotUrl = 'failed'
    }
  },
  [GET_PSAP_LIVESNAPSHOTURL_FAILURE]: function (state) {
    state.status.getLiveSnapshotUrl = 'failed'
  },
  [GET_PSAP_LIVESNAPSHOT_REQUEST]: function (state) {
    state.status.getLiveSnapshot = 'requested'
  },
  [GET_PSAP_LIVESNAPSHOT_SUCCESS]: function (state, {data}) {
    try {
      const timestamp = data.snapshotTimestamp ? data.snapshotTimestamp * 1000 : data.timestamp
      let snapshotInfo = {
        data: 'data:image/jpg;base64,' + data.data,
        timestamp: timestamp
      }
      state.liveSnapshot = snapshotInfo
      state.status.getLiveSnapshot = 'successful'
    } catch (err) {
      Vue.logger.error('GET_PSAP_LIVESNAPSHOT_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getLiveSnapshot = 'failed'
    }
  },
  [GET_PSAP_LIVESNAPSHOT_FAILURE]: function (state) {
    state.status.getLiveSnapshot = 'failed'
  },
  // //////////////////////////////////////////////
  [GET_PSAP_EVENT_REQUEST]: function (state) {
    state.status.getPsapEvent = 'requested'
  },
  [GET_PSAP_EVENT_SUCCESS]: function (state, {data}) {
    try {
      let eventInfo = {
        eventId: data.event_id,
        eventStatus: data.status,
        eventType: data.type,
        eventTimestamp: data.timestamp,
        deviceInfo: {
          deviceId: data.device_id
        }
      }
      state.event = eventInfo
      state.status.getPsapEvent = 'successful'
    } catch (err) {
      Vue.logger.error('GET_PSAP_EVENT_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getPsapEvent = 'failed'
    }
  },
  [GET_PSAP_EVENT_FAILURE]: function (state) {
    state.status.getPsapEvent = 'failed'
  },
  // //////////////////////////////////////////////
  [GET_PSAP_EVENT_MEDIAS_REQUEST]: function (state) {
    state.status.getEventMedias = 'requested'
  },
  [GET_PSAP_EVENT_MEDIAS_SUCCESS]: function (state, {data}) {
    try {
      let eventMediasInfoList = []
      data.map(eventMediasData => {
        if ((eventMediasData.format + '').toLowerCase() === 'jpg' ||
        (eventMediasData.format + '').toLowerCase() === 'mp4'
        ) {
          let eventMediasInfo = {
            recordId: eventMediasData.record_id,
            eventId: eventMediasData.event_id,
            url: eventMediasData.url,
            format: (eventMediasData.format + '').toLowerCase(),
            deviceInfo: {
              deviceId: eventMediasData.device_id
            },
            statusInfo: {
              createdDate: eventMediasData.created ? new Date(eventMediasData.created) : null,
              reallyUploaded: null, // it is to validate 'eventMediasData.completed'
              codec: null,
              completed: !!eventMediasData.completed
            }
          }
          eventMediasInfoList.push(eventMediasInfo)
        }
      })
      state.eventMedias = eventMediasInfoList
      state.status.getEventMedias = 'successful'
    } catch (err) {
      Vue.logger.error('GET_PSAP_EVENT_MEDIAS_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getEventMedias = 'failed'
    }
  },
  [GET_PSAP_EVENT_MEDIAS_FAILURE]: function (state) {
    state.status.getEventMedias = 'failed'
  },
  // //////////////////////////////////////////////
  [GET_PSAP_EVENT_RECORD_REQUEST]: function (state, {recordId}) {
    state.status.getEventRecord[recordId] = 'requested'
  },
  [GET_PSAP_EVENT_RECORD_SUCCESS]: function (state, {snapshotIndex, recordId, data}) {
    try {
      let urlCreator = window.URL || window.webkitURL
      let imageUrl = urlCreator.createObjectURL(data)
      state.eventRecords = {...state.eventRecords, [recordId]: imageUrl}
      state.status.getEventRecord[recordId] = 'successful'
      // it is to validate 'eventMediasData.completed'
      state.eventMedias[snapshotIndex].statusInfo.completed = true
      state.eventMedias[snapshotIndex].statusInfo.reallyUploaded = true
    } catch (err) {
      Vue.logger.error('GET_PSAP_EVENT_RECORD_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getEventRecord[recordId] = 'failed'
      // it is to validate 'eventMediasData.completed'
      state.eventMedias[snapshotIndex].statusInfo.completed = false
      state.eventMedias[snapshotIndex].statusInfo.reallyUploaded = false
    }
  },
  [GET_PSAP_EVENT_RECORD_FAILURE]: function (state, {snapshotIndex, recordId}) {
    state.status.getEventRecord[recordId] = 'failed'
    // it is to validate 'eventMediasData.completed'
    state.eventMedias[snapshotIndex].statusInfo.completed = false
    state.eventMedias[snapshotIndex].statusInfo.reallyUploaded = false
  },
  [CHECK_EVENT_RECORD_CODEC_DONE]: function (state, {snapshotIndex, codec}) {
    try {
      // UPDATE codec
      if (('' + state.eventMedias[snapshotIndex].format).toLocaleLowerCase() !== 'mp4') return
      state.eventMedias[snapshotIndex].statusInfo.codec = codec
      state.status.checkVideoCodec = 'successful'
      // console.log(state.eventSnapshots[eventId][snapshotIndex].statusInfo.codec)
    } catch (err) {
      Vue.logger.error('CHECK_MONITORING_EVENT_RECORD_CODEC_DONE: Failed')
      Vue.logger.error(err)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/psap.js